/**
 * Whether the homepage may spend bandwidth on the game before anyone asks
 * (BUILD_GAME §12.1: Medium-or-better devices, never under Save-Data).
 * Signals a browser does not expose count as "probably fine", not as a no.
 */
export function canPrefetch(nav = globalThis.navigator ?? {}) {
  const connection = nav.connection;
  if (connection?.saveData) return false;
  if (/(^|-)2g$/.test(connection?.effectiveType ?? '')) return false;
  if (typeof nav.deviceMemory === 'number' && nav.deviceMemory < 4) return false;
  if (typeof nav.hardwareConcurrency === 'number' && nav.hardwareConcurrency < 4) return false;
  return true;
}
